// TODO: replace 'any' with correct types when more time
/* eslint-disable @typescript-eslint/no-explicit-any */

import Icon from 'components/shared/Icon'
import Box from 'components/shared/Box'
import { StyledSlider, StyledThumb, StyledTrack } from './styles'

interface InputSliderProps {
    min: number
    max: number
    value: number
    onChange: (value: number) => void
}

const Thumb = (props: any) => <StyledThumb {...props} />
const Track = (props: any, state: any) => (
    <StyledTrack {...props} index={state.index} />
)

const InputSlider = ({ min, max, value, onChange }: InputSliderProps) => (
    <Box direction="row" align="center" gap={8}>
        <Box
            as="button"
            mt={6}
            onClick={() => {
                const decreased = value - (max - min) * 0.1
                onChange(decreased < min ? min : decreased)
            }}
        >
            <Icon variant="minus" color="secondary_500" size={[24, 24]} />
        </Box>
        <StyledSlider
            defaultValue={min}
            renderTrack={Track}
            renderThumb={Thumb}
            min={min}
            max={max}
            value={value}
            onChange={(value) => {
                if (typeof value === 'number') onChange(value)
            }}
        />
        <Box
            as="button"
            mt={6}
            onClick={() => {
                const increased = value + (max - min) * 0.1
                onChange(increased > max ? max : increased)
            }}
        >
            <Icon variant="plus" color="secondary_500" size={[24, 24]} />
        </Box>
    </Box>
)

export default InputSlider
